module.exports = __webpack_public_path__ + "static/media/arroLeft.648d7174.png";